export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <circle cx="32" cy="32" r="29" fill="none" stroke="#D4AF37" strokeWidth="1.2" opacity="0.55" />
    <circle cx="32" cy="32" r="22" fill="none" stroke="#D4AF37" strokeWidth="1.4" />
    <path d="M38 13a19 19 0 1 0 0 38a15 15 0 1 1 0-38z" fill="#D4AF37" />
    <path d="M41 21l1.9 5.4L48 28.3l-5.1 1.9L41 35.6l-1.9-5.4L34 28.3l5.1-1.9z" fill="#F3E5AB" />
    {[0, 90, 180, 270].map((r) => (
      <line key={r} x1="32" y1="1.5" x2="32" y2="6" stroke="#D4AF37" strokeWidth="1.2" transform={`rotate(${r} 32 32)`} />
    ))}
  </svg>
);

export const Logo = ({ testId = "brand-logo" }) => (
  <span className="flex items-center gap-3" data-testid={testId}>
    <LogoMark />
    <span className="leading-none">
      <span className="font-cinzel block text-[13px] tracking-[0.22em] text-[#F3E5AB] sm:text-sm">ASTROLOGER</span>
      <span className="font-display block text-[15px] italic text-slate-300">&amp; Spiritual Healers</span>
    </span>
  </span>
);
